"use client";

import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { User, Mail, ArrowDown } from "lucide-react";
import Link from "next/link";

export function AnimatedButtons() {
  return (
    <motion.div 
      className="flex flex-wrap justify-center lg:justify-start gap-3 md:gap-4"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: 1.2 }}
    >
      <Link href="#about" passHref>
        <motion.div
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          <Button
            className="bg-terminal-background/50 text-terminal-cyan border border-terminal-cyan/20 hover:bg-terminal-cyan/20"
          >
            <User className="mr-2 h-4 w-4" />
            About Me
          </Button>
        </motion.div>
      </Link>
      <Link href="#contact" passHref>
        <motion.div
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          <Button
            variant="outline"
            className="border-terminal-pink/30 text-terminal-pink hover:bg-terminal-pink/10"
          >
            <Mail className="mr-2 h-4 w-4" />
            Contact Me
          </Button>
        </motion.div>
      </Link>
    </motion.div>
  );
}

export function AnimatedScrollButton() {
  return (
    <motion.div 
      className="flex justify-center mt-8 lg:mt-4"
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: 1.4 }}
    >
      <a
        href="#about"
        className="animate-bounce p-2 rounded-full bg-terminal-background/30 text-terminal-pink hover:bg-terminal-background/50 transition-colors"
        aria-label="Scroll down"
      >
        <ArrowDown className="h-5 w-5 sm:h-6 sm:w-6" />
      </a>
    </motion.div>
  );
}